module.exports = __webpack_public_path__ + "static/media/downtown-campus.a9211caa.webp";